import { useCallback } from "react";

const useRequestUploads = ({
  requestId,
  setDragTarget,

  setSelfTicketBillFile,
  setSelfTicketBillName,
  setSelfTicketBillUrl,

  setSelfHotelBillFile,
  setSelfHotelBillName,
  setSelfHotelBillUrl,

  setSelfPaymentProofFile,
  setSelfPaymentProofName,
  setSelfPaymentProofUrl,

  setFormData,
  clearErrorFor,
}) => {
  const handleDragOver = useCallback(
    (e, target) => {
      e.preventDefault();
      setDragTarget(target);
    },
    [setDragTarget],
  );

  const handleDragLeave = useCallback(
    (e) => {
      e.preventDefault();
      setDragTarget(null);
    },
    [setDragTarget],
  );

  const handlePaymentProofChange = useCallback(
    (e) => {
      const selectedFile = e.target.files[0];
      if (!selectedFile) return;

      const previewUrl = URL.createObjectURL(selectedFile);

      setSelfPaymentProofFile(selectedFile);
      setSelfPaymentProofName(selectedFile.name);
      setSelfPaymentProofUrl(previewUrl);

      setFormData((prev) => ({
        ...prev,
        paymentProof: "PENDING_UPLOAD",
      }));

      clearErrorFor("paymentProof");
    },
    [
      setSelfPaymentProofFile,
      setSelfPaymentProofName,
      setSelfPaymentProofUrl,
      setFormData,
      clearErrorFor,
    ],
  );

  const handlePaymentProofDelete = useCallback(() => {
    setSelfPaymentProofFile(null);
    setSelfPaymentProofName("");
    setSelfPaymentProofUrl("");

    setFormData((prev) => ({
      ...prev,
      paymentProof: null,
    }));
  }, [
    setSelfPaymentProofFile,
    setSelfPaymentProofName,
    setSelfPaymentProofUrl,
    setFormData,
  ]);

  const handleSelfBookingFileChange = useCallback(
    (e, type) => {
      const selectedFile = e.target.files[0];
      if (!selectedFile) return;

      const previewUrl = URL.createObjectURL(selectedFile);

      const fieldName =
        type === "ticket" ? "selfBookedTicketBill" : "selfBookedHotelBill";

      if (type === "ticket") {
        setSelfTicketBillFile(selectedFile);
        setSelfTicketBillName(selectedFile.name);
        setSelfTicketBillUrl(previewUrl);
      } else {
        setSelfHotelBillFile(selectedFile);
        setSelfHotelBillName(selectedFile.name);
        setSelfHotelBillUrl(previewUrl);
      }

      setFormData((prev) => ({
        ...prev,
        [fieldName]: requestId ? "NEW_UPLOAD" : selectedFile,
        selfBooked: true,
      }));

      clearErrorFor(fieldName);
    },
    [
      requestId,
      setSelfTicketBillFile,
      setSelfTicketBillName,
      setSelfTicketBillUrl,
      setSelfHotelBillFile,
      setSelfHotelBillName,
      setSelfHotelBillUrl,
      setFormData,
      clearErrorFor,
    ],
  );

  const handleSelfBookingFileDelete = useCallback(
    (type) => {
      const fieldName =
        type === "ticket" ? "selfBookedTicketBill" : "selfBookedHotelBill";

      if (type === "ticket") {
        setSelfTicketBillFile(null);
        setSelfTicketBillName("");
        setSelfTicketBillUrl("");
      } else {
        setSelfHotelBillFile(null);
        setSelfHotelBillName("");
        setSelfHotelBillUrl("");
      }

      setFormData((prev) => ({
        ...prev,
        [fieldName]: null,
      }));
    },
    [
      setSelfTicketBillFile,
      setSelfTicketBillName,
      setSelfTicketBillUrl,
      setSelfHotelBillFile,
      setSelfHotelBillName,
      setSelfHotelBillUrl,
      setFormData,
    ],
  );

  const handleIdProofChange = useCallback(
    (e, index) => {
      const file = e.target.files[0];

      if (!file) return;

      const url = URL.createObjectURL(file);

      setFormData((prev) => {
        const updatedIndividuals = [...prev.individuals];

        updatedIndividuals[index].idProof = file;
        updatedIndividuals[index].idProofUrl = url;
        updatedIndividuals[index].existingIdProof = null;

        return {
          ...prev,
          individuals: updatedIndividuals,
        };
      });

      clearErrorFor(`individual_${index}_idProof`);
    },
    [setFormData, clearErrorFor],
  );

  const handleIdProofDelete = useCallback(
    (index) => {
      setFormData((prev) => {
        const updatedIndividuals = [...prev.individuals];

        updatedIndividuals[index].idProof = null;
        updatedIndividuals[index].idProofUrl = "";
        updatedIndividuals[index].existingIdProof = null;

        return {
          ...prev,
          individuals: updatedIndividuals,
        };
      });
    },
    [setFormData],
  );

  return {
    handleDragOver,
    handleDragLeave,

    handlePaymentProofChange,
    handlePaymentProofDelete,

    handleSelfBookingFileChange,
    handleSelfBookingFileDelete,

    handleIdProofChange,
    handleIdProofDelete,
  };
};

export default useRequestUploads;
